import { render } from "./SafetyCreateView.vue?vue&type=template&id=c57d38ea&ts=true"
import script from "./SafetyCreateView.vue?vue&type=script&lang=ts"
export * from "./SafetyCreateView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__